export default {
  brand: {
    name: "Arman Delivery",
    full: "Arman Delivery & Taxi",
    sub: "& Taxi · Yerevan",
  },
  language: {
    label: "Language",
    en: "English",
    hy: "Armenian",
    ru: "Russian",
  },
  nav: {
    home: "Home",
    services: "Services",
    fleet: "Fleet",
    how: "How to Lease",
    pricing: "Pricing",
    service: "Service Center",
    faq: "FAQ",
    contact: "Contact",
    callNow: "Call now",
    whatsapp: "WhatsApp us",
  },
  wa: {
    nav: "Hi Arman Delivery, I would like to lease a vehicle in Yerevan",
    hero: "Hi Arman Delivery, I want to lease a bike in Yerevan",
    fleet: "Hi Arman Delivery, I want to lease {{vehicle}}",
    pricing: "Hi Arman Delivery, I am interested in the {{plan}} plan",
    how: "Hi Arman Delivery, I want to start the lease process",
    service: "Hi Arman, I need service for my vehicle",
    contact: "Hi Arman Delivery, I would like to lease a vehicle",
    footer: "Hi Arman Delivery, I have a question",
    float: "Hi Arman Delivery, I need info about leasing a vehicle",
  },
  hero: {
    badge: "Armenia · Yerevan · Since day one",
    title1: "Lease a bike,",
    title2: "ride to earn",
    title3: "every day",
    paragraph:
      "<b>{{brand}}</b> offers the most affordable weekly lease of bikes, scooters and cars for delivery riders in Yerevan. Start earning with food & courier platforms — we handle the ride, the service and the spare parts.",
    ctaWhatsapp: "Chat on WhatsApp",
    ctaFleet: "View our fleet",
  },
  stats: {
    riders: "Riders served",
    vehicles: "Active vehicles",
    support: "Support & service",
    rates: "Weekly Yerevan rates",
  },
  marquee: {
    bike: "Weekly bike lease",
    scooter: "Scooter rental",
    car: "Car lease",
    service: "Service center",
    parts: "All spare parts",
    whatsapp: "WhatsApp support 24/7",
    location: "Rubiniants Street 28/1, Zeytun",
  },
  services: {
    eyebrow: "What we offer",
    title1: "One stop solution for",
    title2: "delivery riders in Armenia",
    subtitle:
      "From leasing to servicing to spare parts — Arman Delivery has your whole rider journey covered.",
    learnMore: "Learn more",
    bike: {
      title: "Bike lease",
      description:
        "Affordable weekly bike lease for food delivery, courier work and personal rides across Yerevan.",
    },
    scooter: {
      title: "Scooter lease",
      description:
        "Fuel-efficient automatic scooters that are perfect for city delivery routes, at the lowest weekly rates in town.",
    },
    car: {
      title: "Car lease",
      description:
        "Reliable sedans and hatchbacks for taxi drivers and long-distance delivery partners.",
    },
    service: {
      title: "Service center",
      description:
        "On-site full service, oil changes, tuning and repairs for every vehicle we lease out.",
    },
    parts: {
      title: "Spare parts",
      description:
        "Original and OEM spare parts stocked in-house, so your vehicle is never off the road for long.",
    },
    roadside: {
      title: "Roadside support",
      description:
        "Breakdown help across Yerevan. One call or one WhatsApp message and we come to you.",
    },
  },
  fleet: {
    eyebrow: "Our fleet",
    title1: "Choose your ride,",
    title2: "the Yerevan standard",
    subtitle:
      "All weekly rates below match the current Yerevan market standard. Fully insured, road-tested and serviced by our own workshop.",
    weeklyRate: "Weekly rate",
    lease: "Lease",
    perWeek: "{{price}} AMD / week",
    fuelPetrol: "Petrol · {{value}} km/L",
    seats: "{{count}} seater",
    categories: {
      all: "All",
      bikes: "Bikes",
      scooters: "Scooters",
      cars: "Cars",
    },
    badges: {
      foodDelivery: "Best for food delivery",
      mileage: "Best mileage bike",
      comfort: "Comfort delivery ride",
      courier: "Powerful courier bike",
      taxi: "Best for taxi drivers",
      family: "Family taxi ride",
      premium: "Premium delivery bike",
    },
  },
  how: {
    eyebrow: "How to lease",
    title: "Ride out in 4 easy steps",
    subtitle: "Simple, fast and transparent. Start your delivery career with Arman today.",
    cta: "Start my lease today",
    choose: {
      title: "Choose your vehicle",
      description:
        "Browse our fleet of bikes, scooters or cars and pick the model that fits your job and budget.",
    },
    docs: {
      title: "Submit documents",
      description:
        "Bring your passport, driving license and one photo. We prepare a simple weekly lease agreement on the spot.",
    },
    pay: {
      title: "Pay weekly rent",
      description:
        "Pay only for the week you ride. No long contracts and prices that follow the standard Yerevan market.",
    },
    ride: {
      title: "Ride & earn",
      description:
        "Take the keys and start earning with any food or courier platform in Armenia the very same day.",
    },
  },
  pricing: {
    eyebrow: "Weekly pricing",
    title1: "Weekly rent at",
    title2: "Yerevan standard rates",
    subtitle:
      "Transparent pricing with no hidden charges. You only ever pay for the week you ride.",
    note: "Rates may vary by vehicle model. A refundable deposit applies. Contact us on WhatsApp for an exact quote.",
    plans: {
      bike: {
        name: "Bike weekly",
        tag: "Lowest price",
        unit: "AMD / week",
        cta: "Lease a bike",
        f1: "Ideal for food & courier delivery",
        f2: "Weekly billing, no long contract",
        f3: "Free basic maintenance",
        f4: "Roadside assistance included",
        f5: "Helmet & delivery box add-on",
      },
      scooter: {
        name: "Scooter weekly",
        tag: "Most popular",
        unit: "AMD / week",
        cta: "Lease a scooter",
        f1: "Automatic and easy to ride",
        f2: "Perfect for new riders",
        f3: "Weekly service check-up",
        f4: "Priority spare parts access",
        f5: "Delivery box included",
      },
      car: {
        name: "Car weekly",
        tag: "Yerevan standard",
        unit: "AMD / week",
        cta: "Lease a car",
        f1: "Suits taxi & long-route delivery",
        f2: "Full insurance included",
        f3: "Free oil change every month",
        f4: "4-5 seater options",
        f5: "Fuel-efficient models",
      },
    },
  },
  service: {
    eyebrow: "Service center & spare parts",
    title1: "One stop solution.",
    title2: "From lease to last bolt.",
    subtitle:
      "Every vehicle we lease out is fully supported by our own service center on Rubiniants Street in Zeytun. Break down, small repair or spare part — we handle it all quickly, honestly and at a fair price.",
    turnaround: "2 hrs",
    turnaroundLabel: "Avg. service turnaround",
    rating: "Rated by 300+ riders",
    bookBtn: "Book a service",
    callBtn: "Call workshop",
    workshop: {
      title: "Full-service workshop",
      description: "Certified mechanics for bikes, scooters and cars, all under one roof.",
    },
    parts: {
      title: "Genuine spare parts",
      description: "A full inventory of OEM and original parts, so you never wait days for a repair.",
    },
    maintenance: {
      title: "Free basic maintenance",
      description: "Every leased vehicle gets free oil changes and safety check-ups.",
    },
    guarantee: {
      title: "Quality guarantee",
      description: "A 30-day service warranty on every repair we carry out in our workshop.",
    },
  },
  testimonials: {
    eyebrow: "Rider stories",
    title1: "Trusted by Yerevan's",
    title2: "delivery community",
    davit: {
      role: "Glovo rider",
      quote:
        "Started with Arman last summer on a Splendor bike. The weekly rate is honestly the cheapest in Yerevan, and whenever I need service they fix it the same day.",
    },
    narek: {
      role: "Yandex Delivery",
      quote:
        "Their scooter saved me from public transport chaos. Fuel is cheap and service is free the first month. Highly recommended for delivery guys.",
    },
    aram: {
      role: "Taxi driver",
      quote:
        "I lease a car weekly from Arman for taxi work. Transparent price, no games and no surprises. Their spare parts stock is amazing.",
    },
  },
  faq: {
    eyebrow: "FAQs",
    title: "Everything you want to know",
    documents: {
      q: "What documents do I need to lease a bike or car?",
      a: "You need a valid Armenian or international driving license, a passport or ID card, one recent photo and a refundable security deposit. That is all, and we prepare a simple weekly agreement on the spot.",
    },
    weekly: {
      q: "How much is the weekly rent for a bike in Yerevan?",
      a: "Weekly bike leases start from 30,000 AMD, scooters from 17,000 AMD and cars from 55,000 AMD. Rates follow the standard Yerevan market and may vary slightly by model.",
    },
    support: {
      q: "Do you provide service and spare parts for leased vehicles?",
      a: "Yes. Every vehicle we lease is fully supported by our own service center on Rubiniants Street. Basic maintenance is free for lease customers and we stock genuine spare parts in-house.",
    },
    delivery: {
      q: "Can I use the vehicle for Glovo, Yandex or Wolt delivery?",
      a: "Absolutely. Our fleet is built for delivery work, and the vast majority of our riders use their vehicle for Glovo, Yandex, Wolt and other courier platforms across Yerevan.",
    },
    breakdown: {
      q: "What if the vehicle breaks down during my shift?",
      a: "Call or message us on WhatsApp. We offer roadside assistance across Yerevan and will repair or replace a faulty vehicle as quickly as possible so you can keep earning.",
    },
    sell: {
      q: "Do you sell spare parts to non-lease customers?",
      a: "Yes. Anyone can buy spare parts from our workshop, not only lease customers. Come by the shop or message us with the part you need for a quick price.",
    },
  },
  contact: {
    eyebrow: "Get in touch",
    title1: "Let's get you",
    title2: "on the road today",
    subtitle:
      "Come to our workshop or reach us on WhatsApp — usually we reply in under 5 minutes.",
    whatsappTitle: "WhatsApp us instantly",
    whatsappSub: "Fastest reply · 24/7",
    callTitle: "Call directly",
    callHours: "Mon-Sun · 9:00 - 21:00",
    visitTitle: "Visit our workshop",
    addressLine: "Rubiniants Street 28/1, Zeytun",
    addressCity: "Yerevan 0069, Armenia",
    form: {
      title: "Send a lease inquiry",
      subtitle: "Tell us what you need and we'll get back to you on WhatsApp or by phone.",
      name: "Full name *",
      namePlaceholder: "Your name",
      phone: "Phone / WhatsApp *",
      email: "Email",
      vehicleLabel: "Vehicle interest *",
      vehiclePlaceholder: "Select a vehicle type",
      optionBike: "Bike lease",
      optionScooter: "Scooter lease",
      optionCar: "Car lease",
      optionService: "Service / repair",
      optionParts: "Spare parts",
      optionHero: "Hero Splendor (new)",
      message: "Message",
      messagePlaceholder: "Tell us what you need...",
      maxChars: "Max 500 characters",
      submit: "Send inquiry",
      sending: "Sending...",
      success: "Thank you. Your inquiry has been sent and we'll get back to you shortly.",
      errorNetwork: "Network error. Please try again or message us on WhatsApp.",
      errorGeneric: "We could not send your inquiry. Please try again or message us on WhatsApp.",
    },
  },
  footer: {
    about:
      "Your one-stop lease partner for bikes, scooters and cars in Yerevan, Armenia. Ride out today with the lowest weekly rates in the city.",
    services: "Services",
    company: "Company",
    contact: "Contact",
    bike: "Bike lease",
    scooter: "Scooter lease",
    car: "Car lease",
    serviceCenter: "Service center",
    spare: "Spare parts",
    how: "How to lease",
    pricing: "Weekly pricing",
    faq: "FAQs",
    whatsappChat: "WhatsApp chat",
    hours: "Mon-Sun · 9:00 - 21:00",
    rights: "© 2026 Arman Delivery & Taxi. All rights reserved.",
    curated: "Curated by SkyEdge Infotech LLC",
  },
  whatsappFloat: "Chat with us",
};